import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'elemental-input',
  templateUrl: './elemental-input.component.html'

})
export class ElementalInputComponent implements OnInit {
  @Input() name: string;
  @Input() placeholder: string;
  @Input() assessment: any;
  @Input() question: any;

  @Output() answerChanged = new EventEmitter();

  @ViewChild('textAreaInput') textAreaInput: any;
  @ViewChild('divTextInput') divTextInput: any;

  constructor() { }

  ngOnInit(): void {
  }

  internalAnswerChanged(answer, answerId, isAssessment) {
    this.answerChanged.emit({ answer: answer, answerId: answerId, isAssessment: isAssessment });
  }

  ngAfterViewInit() {
    this.textAreaInput.nativeElement.style.height = (this.divTextInput.nativeElement.getBoundingClientRect().height * 1.1) + 'px';
    this.divTextInput.nativeElement.classList.add('d-none');
    this.textAreaInput.nativeElement.classList.remove('d-none');
  }
}
